module.exports = __webpack_public_path__ + "img/user.1f179a7c.svg";